import Vue from 'vue'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')
// axios 配置
axios.defaults.timeout = 20000
axios.defaults.headers.post['Content-Type'] = 'application/json'
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Accept'] = 'application/json'
// axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.access_token
// axios.defaults.withCredentials = false
//
// if (localStorage.access_token !== undefined) {
//   console.log('Authorization:', localStorage.access_token)
//   axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.access_token
// } else {
//   console.log('localStorage.access_token is undefined')
// }
//
axios.defaults.baseURL = constants.AXIOS_DEFAULT_BASEURL

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          // TODO: 修改登录错误提示为：密码错误
          console.log('axios interception error 400')
          bus.$emit(constants.EVENT_BUS_LOGIN_ERROR_400, '400')
          break
        case 401:
          // FIXME: 401报错自动清理本地存储access_token, 然后重新获取access_token
          console.log('axios interception error 401')
          bus.$emit(constants.EVENT_BUS_LOGOUT, '401')
          break
        case 403:
          // TODO: 通过refresh_token获取最新access_token?
          // 403 无权限，跳转到首页
          console.log('axios interception error 403')
          bus.$emit(constants.EVENT_BUS_LOGOUT, '403')
          break
        case 500:
          // TODO: 服务器错误
          console.log('axios interception error 500')
          bus.$emit(constants.EVENT_BUS_SERVER_ERROR_500, '500')
          break
      }
    }
    return 'return axios interception error'
  })

// request interceptor
axios.interceptors.request.use(config => {
  const token = Vue.ls.get(constants.ACCESS_TOKEN)
  if (token) {
    // config.headers['Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    config.headers['Authorization'] = 'Bearer ' + token
    // config.headers['Content-Type'] = 'application/json'
  }
  return config
}, error => {
  if (error.response) {
    const data = error.response.data
    if (error.response.status === 403) {
      bus.$emit(constants.EVENT_BUS_LOGOUT, '403')
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      bus.$emit(constants.EVENT_BUS_LOGOUT, '401')
    }
  }
  return Promise.reject(error)
})
